export default "__VITE_ASSET__DuQRaF$f__"